module.exports = __webpack_public_path__ + "static/img/btn_shibai_nor@3x.84088fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/IdentitAuthentication/images/btn_shibai_nor@3x.png
// module id = j5kn
// module chunks = 1